export default __webpack_public_path__ + "static/media/nomina_sat.201127d1.png";